import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import ReactTable from "react-table";
import 'react-table/react-table.css';



//import Moment from "moment";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class CountryList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            countries: [],
            regions: [],
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
    }
    

    async componentDidMount() {
        
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        
        try {
            const countries = await this.getCountries();
            this.setState({ countries });
            await this.getRegions();
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ countries: [] });        
    }


    
    async getCountries() {
        
        
        return API.get("colin", "/countries/all");
      
    }

    async getRegions() {
        try {
            console.log("In getRegions");
            API.get("colin", "/regions").then((regions) => {
                if (regions ) {
                    this.setState(state => ({ regions }));
                }
            });
        }
        catch{
            console.log("Error getting regions");
        }
    }
    

    addRecord = async event => {
        let countries = [...this.state.countries];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        countries.unshift({
            country_code:"",
            country: "",
            region_code: "",

            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({countries});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/countries/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/countries/${record["country_code"]}`, {
            body: record
        });
        
        

       
    }

    validateRecord(record) {

       
        if (record.country_code === "") {
            return [false,"Code cannot be blank. The record has not been saved"];
        }

        if (record.country === "") {
            return [false,"Country cannot be blank. The record has not been saved"];
        }

        if (record.region_code=== "") {
            return [false,"Region cannot be blank. The record has not been saved"];
        }
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let countries = [...this.state.countries];
        
        if (cellInfo.column.id === "country_code" && !countries[cellInfo.index].new_record)
        {
            alert("You cannot modify an existing country code");
            return
        }
        countries[cellInfo.index][cellInfo.column.id] = event.target.value;
        countries[cellInfo.index].modified = true;
        this.setState({countries});
    };
    handleNumberChange = (cellInfo, event) => {
        let countries = [...this.state.countries];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        countries[cellInfo.index][cellInfo.column.id] = Number(val);
        countries[cellInfo.index].modified = true;
        this.setState({countries});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let countries = [...this.state.countries];
        countries[cellInfo.index][cellInfo.column.id] = event.target.checked;
        countries[cellInfo.index].modified = true;
        this.setState({countries});
    };

    handleDateChange = (cellInfo, event) => {
        let countries = [...this.state.countries];
        countries[cellInfo.index][cellInfo.column.id] = new Date(event);
        countries[cellInfo.index].modified = true;
        this.setState({countries});

    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let countries = [...this.state.countries];
        for (var i=0; i<countries.length; i++){
            const validation = this.validateRecord(countries[i]);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (countries[i].hasOwnProperty("modified")) {
                    if (countries[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (countries[i].hasOwnProperty("new_record")) {
                                if (countries[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(countries[i]);
                            if (result.result) {
                                countries[i].modified = false;
                                if (countries[i].hasOwnProperty("new_record")) {
                                    if (countries[i].new_record === true) {

                                  //      countries[i].id = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    countries[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (countries[0].hasOwnProperty("sort_order")) {
            countries.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({countries});

    }

    handleRegionChange = (cellInfo, event) => {
        let countries = [...this.state.countries];
        console.log(event);
        countries[cellInfo.index][cellInfo.column.id] = event.value;
        countries[cellInfo.index].modified = true;
        this.setState({countries});

    }

    renderEditable = cellInfo => {
        const cellValue = this.state.countries[cellInfo.index][cellInfo.column.id];

        if (cellInfo.column.id == "region_code") {
            if (cellValue && this.state.regions.length>0) {
                return (<div><Select
                    value={{ value: cellValue, label: this.state.regions.find(o => o.value === cellValue).label }}
                    onChange={this.handleRegionChange.bind(null, cellInfo)}
                    options={this.state.regions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                /></div>
                );
            }
            else {
                return (<div><Select

                    onChange={this.handleRegionChange.bind(null, cellInfo)}
                    options={this.state.regions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                /></div>
                );
            }
        }

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [

            {
                id: 'country_code',
                Header: 'Code',
                maxWidth: 150,
                accessor: 'country_code' ,
                Cell: this.renderEditable                
        },
        {
                id: 'country',
                Header: 'Country',
                maxWidth: 350,
                accessor: 'country' ,
                Cell: this.renderEditable                
        },
        {
                id: 'region_code',
                Header: 'Region',
                maxWidth: 350,
                id: 'region_code',
                accessor: 'region_code' ,
                Cell: this.renderEditable                
        }
        
         
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={100}
                    sortable={false}
                />
            )
        }
    }

    
    renderComponent() {
        return (
            <div className="countries">
            <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Alert show={this.state.showAlert} variant="danger" dismissible >{this.state.errorMessage}</Alert>
                <Row >
                    <Col className="text-right" >                            
                            <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.countries) : this.renderTable(this.state.countries)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="CityscopeList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
